import { Component } from '@angular/core';

@Component({
  selector: 'lx-payment-card-options',
  standalone: true,
  templateUrl: './payment-card-options.component.html',
  styleUrls: ['./payment-card-options.component.scss'],
})
export class PaymentCardOptionsComponent {}
